export default {
  memberReferral: 'แนะนำเพื่อน',
  'memberReferral.title': 'ชวนเพื่อนมารับรางวัลด้วยกัน',
  'memberReferral.description':
    'ให้เพื่อนใส่รหัสแนะนำตอนสมัครสมาชิก<br />หรือคลิกลิงก์แนะนำเพื่อสมัคร',
  'memberReferral.code': 'รหัสแนะนำ',
  'memberReferral.url': 'ลิงก์แนะนำ',
  'memberReferral.copy.success': 'คัดลอกสำเร็จ!',
  'memberReferral.message.disabled': 'ขณะนี้อยู่นอกช่วงกิจกรรม!',
  'memberReferral.message.title': 'ขอเชิญคุณเข้าร่วม {name} ด้วยกัน',
  'memberReferral.message.description':
    'รหัสแนะนำเพื่อน: {code} กรุณาใส่รหัสตอนสมัคร หรือคลิกลิงก์แนะนำเพื่อสมัคร',
  'memberReferral.message.join': 'สมัครสมาชิก',
  'memberReferral.message.share': 'แชร์',
  'memberReferral.message.success': 'แชร์ลิงก์แนะนำเรียบร้อยแล้ว!',
  'memberReferral.message.version': 'LINE เวอร์ชันเก่าเกินไป กรุณาอัปเดตแล้วลองใหม่อีกครั้ง',
  'memberReferral.message.fail': 'แชร์ไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
} as Record<string, string>;
